module.exports = __webpack_public_path__ + "static/media/flooring_material_10y_y.e2d8a8e3.csv";